<template>
	<div>
		<div class="page-bg">


			<div class="points-ranking-page">
				<div class="logo">
					<img src="../assets/logo.png" alt="" />
				</div>

				<div class="title-bar fcc">
					<img src="../assets/slogen-page.png" alt="" />
				</div>
				<div class="points-ranking-title fcc">
					<!-- <h3><span>组队积分榜</span></h3> -->
					 <img src="../assets/zdjfb.png" alt="" />
				</div>
				<div class="points-ranking-list">
					<div class="th">
						<div class="col1">排名</div>
						<div class="col2">班级</div>
						<div class="col3">积分</div>
					</div>
					<div class="td" v-for="(item, index) in rankObj.rankList" :key="index" :class="{ on: index % 2 }">
						<div class="col1">
							<div class="txt">{{ index + 1 }}</div>
						</div>
						<div class="col2">
							<div class="txt">{{ item.className }}</div>
						</div>
						<div class="col3">
							<div class="tt">{{ item.integral }}</div>
						</div>
					</div>
				</div>


				<div class="points-ranking-title fcc">
					<!-- <h3><span>我的积分</span></h3> -->
					<img src="../assets/wdjf.png" alt="" />
				</div>
				<div class="points-ranking-list">
					<div class="th">
						<div class="col1">姓名</div>
						<div class="col3">积分</div>
					</div>
					<div class="td">
						<div class="col1">
							<div class="txt">{{ rankObj.userName }}</div>
						</div>

						<div class="col3">
							<div class="tt">{{ rankObj.userIntegralTotal }}</div>
						</div>
					</div>
				</div>
			</div>

			<i-nav></i-nav>
		</div>


		<van-overlay :show="showLoading">
			<div class="fcc-h " style="height: 100vh;">
				<van-loading size="24px" vertical color="#fff">加载中...</van-loading>
			</div>
		</van-overlay>

	</div>
</template>

<script>


import { rank } from "@/api/api";

export default {

	data() {
		return {
			rankObj: {},
			showLoading: false,
			uid: null
		};
	},
	async mounted() {
		this.uid = window.localStorage.getItem('cscec2026UserId')
		if (!this.uid) {
			this.$router.push({ path: '/' })
			return
		}
		this.rankFun()
	},
	methods: {
		rankFun() {
			this.showLoading = true
			rank({ userId: window.localStorage.getItem('cscec2026UserId') }).then(res => {
				console.log(res);
				this.rankObj = res
				this.$forceUpdate()
			}).finally(() => {
				this.showLoading = false
			})
		}

	},
};
</script>
<style scoped lang="less"></style>
